module.exports = __webpack_public_path__ + "img/referral.70fe8837.svg";